<template>
  <div class="guidiance">
    <CommonTitle titleName="帮助中心" />
    <div class="contentBox" v-html="content"></div>
    <div class="footerBox" @click="handleOpenAdvisory">
      <p>未解决，联系人工客服</p>
    </div>
    <ChatType v-if="chatTypeShow" @closeAdvisory="handleCloseAdvisory" />
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { getHelpContent } from '@/api/personal/helpCenter/index';
import ChatType from '../../arkHome/components/chatType.vue';

export default {
  data() {
    return {
      content: '',
      chatTypeShow: false,
    };
  },

  components: {
    CommonTitle,
    ChatType,
  },

  created() {
    const id = this.$route.query.guidianceId;
    this.getContent(id);
  },

  methods: {
    async getContent(id) {
      const result = await getHelpContent(id); // category接口
      if (result && result.data) {
        this.content = result.data.questionContent;
      }
    },

    handleOpenAdvisory() {
      this.chatTypeShow = true;
    },

    handleCloseAdvisory() {
      this.chatTypeShow = false;
    },
  },
};
</script>

<style lang="scss">
.guidiance {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  width: 100%;
  max-width: 750px;
  margin-top: 100px;
  padding: 20px 32px 0;
  background-color: #fff;

  .contentBox {
    width: 100%;
    overflow: hidden;
  }

  .footerBox {
    position: fixed;
    bottom: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 634px;
    height: 80px;
    background: #ff7f41;
    border-radius: 45px;
  }

  .footerBox > p {
    color: #fff;
    font-weight: 500;
    font-size: 33px;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    line-height: 45px;
  }
}

img {
  width: 100%;
  // margin: 10px 0;
  object-fit: cover;
}
</style>
